// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/oopsyraidsy/data/04-sb/trial/byakko-ex.ts

import NetRegexes from '../../../../../resources/netregexes';
import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';
import { playerDamageFields } from '../../../oopsy_common';

export type Data = OopsyData;

// Byakko Unreal
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.TheJadeStoaUnreal,
  damageWarn: {
    // Popping Unrelenting Anguish bubbles
    'ByakkoUn Aratama': '9C16',
    // Stepping in growing orb
    'ByakkoUn Vacuum Claw': '9C0A',
    // Lightning Puddles
    'ByakkoUn Hunderfold Havoc 1': '9C06',
    'ByakkoUn Hunderfold Havoc 2': '9C07',
  },
  damageFail: {
    'ByakkoUn Sweep The Leg': '9BFC',
    'ByakkoUn Fire and Lightning': '9BFF',
    'ByakkoUn Distant Clap': '9BFE',
    // Midphase line attack
    'ByakkoUn Imperial Guard': '9C12',
  },
  triggers: [
    {
      // Pink bubble collision
      id: 'ByakkoUn Ominous Wind',
      type: 'Ability',
      netRegex: NetRegexes.ability({ id: '9C0D', ...playerDamageFields }),
      mistake: (_data, matches) => {
        return {
          type: 'warn',
          blame: matches.target,
          reportId: matches.targetId,
          text: {
            en: 'bubble collision',
            de: 'Blasen sind zusammengestoßen',
            fr: 'Collision avec une bulle',
            ja: '衝突',
            cn: '相撞',
            ko: '장판 겹쳐서 터짐',
            tc: '相撞',
          },
        };
      },
    },
  ],
};

export default triggerSet;
